import { ESTADOS_EN_ORDEN } from "./estados";

/**
 * Las reglas de interfaz del cambio de estado de una OT: cuándo se pide motivo,
 * a quién se le ofrece el salto forzado y a qué destinos. Ver ADR 0098.
 *
 * **El worker revalida todo** (invariante 5): esto decide qué se ofrece y cuándo
 * se habilita «Confirmar», no qué se permite. La regla del motivo es la de
 * `apps/worker-api/src/dominio/motivo.ts`; si difieren, manda la del worker y
 * el diálogo muestra su 422.
 */

export const MOTIVO_MIN = 10;
export const MOTIVO_MAX = 500;

/** Code points después de quitar los caracteres de formato (`\p{Cf}`) y recortar. */
export function largoDelMotivo(texto: string): number {
  return [...texto.replace(/\p{Cf}/gu, "").trim()].length;
}

export function motivoEsValido(texto: string): boolean {
  const largo = largoDelMotivo(texto);
  return largo >= MOTIVO_MIN && largo <= MOTIVO_MAX;
}

/** El salto forzado siempre; por el camino ordinario, solo cancelar desde `BORRADOR` (B3). */
export function exigeMotivo(desde: string, hacia: string, forzada: boolean): boolean {
  return forzada || (desde === "BORRADOR" && hacia === "CANCELADA");
}

/** Cualquiera de los dos permisos de salto abre el diálogo (B14). */
export function puedeForzar(canCodigo: (codigo: string) => boolean): boolean {
  return (
    canCodigo("produccion.flexible_transition") || canCodigo("produccion.imprimir_sin_aprobacion")
  );
}

/**
 * Todos los estados menos el actual. `ELIMINADA` no está en `ESTADOS_EN_ORDEN`,
 * y `APROBACION_PENDIENTE → POR_IMPRIMIR` forzado es 422 (B1): registra la
 * aprobación del cliente, así que va por el botón ordinario.
 */
export function destinosForzables(actual: string): string[] {
  // De ELIMINADA no se sale, ni forzando (ADR 0100 A4): el worker contesta 422.
  if (actual === "ELIMINADA") return [];
  return ESTADOS_EN_ORDEN.filter(
    (e) => e !== actual && !(actual === "APROBACION_PENDIENTE" && e === "POR_IMPRIMIR"),
  );
}
